import React from 'react';

const Icon120 = () => (
  <svg
    className="spinner__svg"
    width="120px"
    height="120px"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Spinner">
      <path
        id="base"
        opacity="0.1"
        d="M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM9 60C9 88.1665 31.8335 111 60 111C88.1665 111 111 88.1665 111 60C111 31.8335 88.1665 9 60 9C31.8335 9 9 31.8335 9 60Z"
        fill="currentColor"
      />
      <path
        id="position"
        d="M120 60C120 52.1207 118.448 44.3185 115.433 37.039C112.417 29.7595 107.998 23.1451 102.426 17.5736C96.8549 12.0021 90.2405 7.58251 82.961 4.56723C75.6815 1.55195 67.8793 -3.44416e-07 60 0V9C66.6974 9 73.3292 10.3192 79.5169 12.8821C85.7045 15.4451 91.3267 19.2018 96.0624 23.9376C100.798 28.6733 104.555 34.2955 107.118 40.4831C109.681 46.6707 111 53.3026 111 60H120Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default Icon120;
